import React from 'react';
import { useChatChangeSubscription } from 'src/common/chat/change-subscription.hook';
import { JourneyAlias } from 'src/common/interfaces/journey/alias.interface';
import { JourneyMenuPropsInterface } from 'src/common/JourneyMenu';
import { SmallPanel } from 'src/common/ui/small-panel';
import { DashboardHomeConversationsAliasOption } from './alias-option';

interface Props
  extends Pick<
    JourneyMenuPropsInterface,
    'openRef' | 'closeRef' | 'renderOrigin' | 'onOpen' | 'onClose' | 'placement'
  > {
  aliases: JourneyAlias[];
  onChange: (aliasUUID: JourneyAlias['uuid'], value: boolean) => void;
  onBack: () => void;
}

export const DashboardHomeConversationsPanel = ({ aliases, onChange, ...popoverProps }: Props) => {
  const { updateSubscription } = useChatChangeSubscription();

  const onToggleChanged = async (aliasUUID: JourneyAlias['uuid'], value: boolean) => {
    await updateSubscription(aliasUUID, value);
    onChange(aliasUUID, value);
  };

  return (
    <SmallPanel openAfterMount hasBackButton {...popoverProps}>
      <div className='flex flex-col gap-4'>
        <span className='text-bedrock-p text-bedrock-black'>Get email alerts when this Journey receives a comment</span>
      </div>
      {aliases.map((alias) => (
        <DashboardHomeConversationsAliasOption
          key={alias.slug}
          alias={alias}
          onChange={(value) => onToggleChanged(alias.uuid, value)}
        />
      ))}
    </SmallPanel>
  );
};
